import axios from "axios"
import HostFunctions from "../core/functions/HostFunctions"
import i18n from "../core/i18n"

const api = axios.create({
  baseURL: HostFunctions.getUrlPayRandom(),
  timeout: 500000,
})

export default api

/** Código estável do erro (extensão "code" do ProblemDetails), quando o backend envia. */
export const getResponseErrorCode = (error: any): string | null => {
  const code = error?.response?.data?.code
  return typeof code === "string" && code !== "" ? code : null
}

export const isErrorApi = (error: any) => {
  return axios.isAxiosError(error)
}

export const setAuthorization = (token: string) => {
  if (token !== null && token !== "") {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`
  } else {
    api.defaults.headers.common["Authorization"] = ""
  }
}

export const getResponseError = (error: unknown) => {
  var message = i18n.t("errors.unidentified")

  try {
    const err: any = error
    if (err && err !== null) {
      if (err.response) {
        if (err.response.data) {
          if (err.response.data.errors) {
            try {
              const errors: any[] = err.response.data.errors
              const list = errors.map((item: any) => item.message).join("\n")
              return list
            } catch (e) {
              try {
                const errors: any = err.response.data.title
                return errors.toString()
              } catch (er) {}
            }
          }
          if (err.response.data.detail) {
            return err.response.data.detail
          }
        }
      }
    }
  } catch (e) {
    console.error(e)
  }

  if (typeof error === "string") {
    message = error.toUpperCase()
  } else if (error instanceof Error) {
    const err = error as Error
    message = err.message
  }

  return message
}
